// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

/**
 * @hidden
 */
export type StatusCode = number;
/**
 * @hidden
 */
export type SubStatusCode = number;
